import FolderStore from './schema/FolderStore';
import FolderTreeData from './schema/FolderTreeData';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import FolderTreeLoadStateEnum from '../store/schema/FolderTreeLoadStateEnum';
import { PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID } from 'owa-folders-constants';

const getStore = createStore<FolderStore>('folderStore', {
    folderTable: new ObservableMap(),
    folderTreeTable: new ObservableMap<string, FolderTreeData>({
        [PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID]: {
            id: PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
            rootFolder: null,
            loadingState: FolderTreeLoadStateEnum.Uninitialized,
        },
    }),
    sharedFolderUserEmails: [],
});
export const folderStore = getStore();
export default getStore;
